// © Microsoft Corporation. All rights reserved.

import { ContextBehavior, FeedNavigationData, FeedNavigationItem, FeedNavigationLocalizedStrings, NavigationGroup } from "./Interfaces";

import { FeedNavigation as FeedNavigationBase } from "./FeedNavigation";
import { customElement } from "@microsoft/fast-element";
import { FeedNavigationStyles as styles } from "./FeedNavigation.styles";
import { FeedNavigationTemplate as template } from "./FeedNavigation.template";

/**
 * Microsoft News feed navigation web component
 */
@customElement({
    name: "msn-feed-nav",
    template,
    styles
})
class FeedNavigation extends FeedNavigationBase { }

export {
    FeedNavigation,
    FeedNavigationItem,
    NavigationGroup,
    FeedNavigationData,
    FeedNavigationLocalizedStrings,
    ContextBehavior,
    styles as FeedNavigationStyles,
    template as FeedNavigationTemplate
};
